/* eslint-disable no-undef */
/* eslint-disable no-plusplus */
/* eslint-disable max-len */
import React, { Component } from 'react';
import {
  Container, Row, Col, Button, ModalHeader, ModalBody, Modal, ModalFooter,
} from 'reactstrap';
import {
  faTrash,
} from '@fortawesome/free-solid-svg-icons';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getTreatmentData, editTreatmentData, deleteTreatment } from '../../services/Treatments/actions';
import CreateTreatmentForm from '../../forms/Treatment';
import { CustomLoading } from '../../components/Loading';

const Title = styled.h1`
  text-align: center;
`;

class TreatmentDetails extends Component {
  state = {
    tempTreatmentData: {},
    tempLoading: true,
    deletedFileArray: [],
    deleteTreatmentModal: false,
  };

  constructor(props) {
    super(props);
    this.toggleDeleteTreatmentModal = this.toggleDeleteTreatmentModal.bind(this);
  }

  componentDidMount() {
    const {
      match: {
        params: {
          treatmentId,
        },
      },
    } = this.props;
    this.props.getTreatmentData(this.props.match.params.petId, treatmentId, () => {
      const {
        Treatments: {
          treatmentData,
        },
      } = this.props;

      this.setState({
        tempTreatmentData: treatmentData,
        tempLoading: false,
      });
    });
  }

  handleTreatmentEdit = (values) => {
    const {
      match: {
        params: {
          treatmentId,
          petId,
        },
      },
      history,
    } = this.props;

    const {
      deletedFileArray,
    } = this.state;

    const tempValues = values;
    let tempReports;
    if (values.reports && values.reports[0].name) {
      tempReports = values.reports;
      delete tempValues.reports;
    } else {
      tempReports = null;
    }
    this.props.editTreatmentData(petId, treatmentId, tempValues, deletedFileArray, tempReports, () => {
      const {
        Pets: {
          petData,
        },
      } = this.props;
      if (petData.owner) {
        history.push(`/client/${petData.owner}`);
      } else {
        history.push('/home');
      }
    });
  }

  // Remove file from filelist stored in state
  removeFile = (file) => {
    const {
      tempTreatmentData,
      deletedFileArray,
    } = this.state;

    for (let i = 0; i < tempTreatmentData.reports.length; i++) {
      if (!tempTreatmentData.reports[i].name) {
        if (tempTreatmentData.reports[i] === file) {
          tempTreatmentData.reports.splice(i, 1);
          deletedFileArray.push(file);
          this.setState({
            tempLoading: true,
          }, () => {
            this.setState({
              tempLoading: false,
            });
          });
        }
      }
    }
  }

  toggleDeleteTreatmentModal() {
    this.setState(prevState => ({
      deleteTreatmentModal: !prevState.deleteTreatmentModal,
    }));
  }

  render() {
    const {
      Treatments: {
        isLoading,
      },
    } = this.props;
    const {
      tempTreatmentData,
      tempLoading,
    } = this.state;

    if (isLoading || tempLoading) {
      return (
        <CustomLoading />
      );
    }
    return (
      <Container>
        <Row>
          <Col md={{ size: 8, offset: 2 }}>
            <div className="d-flex flex-column justify-content-center align-items">
              <Title>
                Edit Treatment
              </Title>
            </div>
            <div className="d-flex justify-content-end">
              <Button onClick={this.toggleDeleteTreatmentModal} className="mt-2 mr-2 mb-2" color="danger">
                <FontAwesomeIcon icon={faTrash} />
              </Button>
            </div>
            <CreateTreatmentForm
              isLoading={isLoading}
              onSubmit={this.handleTreatmentEdit}
              initialValues={tempTreatmentData}
              isNew={false}
              removeFile={this.removeFile}
              submitLabel="Update"
            />
          </Col>
        </Row>
        <Modal isOpen={this.state.deleteTreatmentModal} toggle={this.toggleDeleteTreatmentModal}>
          <ModalHeader toggle={this.toggleDeleteTreatmentModal}>
            Delete Treatment?
          </ModalHeader>
          <ModalBody>
            Delete this treatment?
          </ModalBody>
          <ModalFooter>
            <Button
              color="primary"
              onClick={() => {
                this.props.deleteTreatment(this.props.match.params.petId, this.props.match.params.treatmentId, this.state.tempTreatmentData.reports, () => {
                  this.props.history.push(`/client/${this.props.Pets.petData.owner}`);
                });
              }}
            >
              Yes
            </Button>
            <Button color="secondary" onClick={() => { this.toggleDeletePetModal(); }}>
              No
            </Button>
          </ModalFooter>
        </Modal>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  Treatments: state.Treatments,
  Pets: state.Pets,
});

const mapDispatchToProps = {
  getTreatmentData,
  editTreatmentData,
  deleteTreatment,
};

export default connect(mapStateToProps, mapDispatchToProps)(TreatmentDetails);
